import { PropertyMapper } from '../../decorators';

export class ExpenseReportCategory {

    @PropertyMapper({ jsonProperty: 'id' })
    public id: number;

    @PropertyMapper({ jsonProperty: 'name' })
    public name: string;
}
